import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { useAppDispatch, useAppSelector } from './Redux/store';
import { systemThemeChanged } from './Redux/Slices/uiSlice';
import { applyTheme, DARK_MEDIA_QUERY } from './lib/theme';
import AppRoutes from './Routes';

export default function App() {
  const dispatch = useAppDispatch();
  const preference = useAppSelector((s) => s.ui.theme);
  const resolved = useAppSelector((s) => s.ui.resolvedTheme);

  /**
   * Under `system` the theme can change with no user action at all — the phone
   * crosses into its night schedule while the guest is reading the menu. So the
   * media query is subscribed to for as long as the app is open, not sampled
   * once at boot.
   */
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(DARK_MEDIA_QUERY);
    const onChange = (event: MediaQueryListEvent) => dispatch(systemThemeChanged(event.matches));
    query.addEventListener('change', onChange);
    // The store was seeded before this subscription existed; re-read once in
    // case the preference was already stale by the time React mounted.
    dispatch(systemThemeChanged(query.matches));
    return () => query.removeEventListener('change', onChange);
  }, [dispatch, preference]);

  useEffect(() => {
    applyTheme(resolved);
  }, [resolved]);

  // No `/auth/me` here. A guest has no account; the session is restored
  // from the QR scan persisted in `guestSlice`, and asking the staff endpoint
  // with a guest token would 401 and throw the credential away.
  return (
    <>
      <AppRoutes />
      {/* Sonner paints its own surface, so it has to be told which ground it is
          landing on — a white toast over the dark theme is the one bright
          rectangle this app is trying not to show anyone. */}
      <Toaster position="top-center" theme={resolved} richColors closeButton />
    </>
  );
}
